import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var initStateQoData = _define_property({
    id: "",
    dim_mst_qo_status_id: "",
    dim_mst_payment_type_id: "",
    dim_mst_price_category_id: "",
    dim_new_alldernow_emp_id: "",
    fact_member_id: "",
    doc_number: "",
    full_member_name: "",
    full_member_address_name: "",
    member_is_hq: "",
    member_branch_no: "",
    member_additional_info: "",
    member_business_type: "",
    member_customer_type: "",
    member_address: "",
    member_district: "",
    member_amphoe: "",
    member_province: "",
    member_postal_code: "",
    member_phone_number: "",
    dim_warehouse_id: 3,
    dim_branch_id: 3,
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0,
    total_price_before_discount: 0,
    discount_price: 0,
    total_price_after_discount: "",
    total_price_product_no_vat: "",
    total_price_product_zero_vat: "",
    total_price_product_seven_vat: "",
    total_seven_vat_amount: "",
    total_price_vat: "",
    total_price_before_vat: "",
    grand_total_price: "",
    sum_item_quantity: "",
    remark: "",
    doc_issue_date: "",
    is_sort_manual: "",
    not_approve_reason: "",
    canceled_at: "",
    canceled_by_emp_id: ""
}, "member_address", "");
